<script>
	import ProductHeader from '../components/ProductHeader.svelte';
	import ProductDetail from '../components/ProductDetail.svelte';
	import Loader         from '../components/General/Loader.svelte';
	import { getVehicle } from '../lib/api';

	let data;
	const query = new URLSearchParams(window.location.search);
	const id = query.get('id');

	getVehicle(id).then(res => {
		data = res.data;
	});
</script>

{#if data}
	<ProductHeader {data} />
	<ProductDetail {data} />
{:else}
	<div class="loader">
		<Loader />
	</div>
{/if}

<style>
	.loader {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
